import request from './index'
import {
  getToken,
  hideLoading,
  isTextEmpty,
  setSession,
  showFailMessage,
  showLoading,
} from '@/utils'
import bus from '@/utils/bus'
import { showDialog } from 'vant'
import { getCurrentInstance } from 'vue'
/**
 * 根据code进行登录操作
 * @param {*} code
 */
export const login = () => {
  return new Promise((resolve, reject) => {
    window.h5sdk.ready(() => {
      // ready方法不需要每次都调用
      tt.requestAuthCode({
        appId: 'cli_a31aa82f07be1013',
        success: (info) => {
          request
            .post('/v1/login', { code: info.code })
            .then((res) => {
              const { text_shop, text_running, text_shutdown } = res.data.customize
              window.myVueApp.config.globalProperties.KEYS = {
                KEY_STORE_NAME: text_shop ? text_shop : '门店',
                KEY_RUNING_NAME: text_running ? text_running : '营业中',
                KEY_CLOSE_NAME: text_shutdown ? text_shutdown : '已闭店',
              }
              bus.emit('onLogin', res.data)
              // 存储用户信息
              setSession('uinfo', res.data)
              // 如果is_new,跳转到收集手机号页面
              if (res.data.is_new == 1) {
                window.location.replace(
                  window.location.origin + '/first_input_info'
                )
                return
              }
              if (
                res.data.routes &&
                res.data.routes.findIndex(
                  (item) => item === '/patrol_task/task_list'
                ) > -1
              ) {
                bus.emit('ableCreate', 1)
                setSession('ableCreate', 1)
              } else {
                bus.emit('ableCreate', 0)
                setSession('ableCreate', 0)
              }
              // 配置飞书API
              configApi()
              // 回调
              resolve(true)
            })
        },
        fail: (error) => {
          console.error(error)
          // alert(JSON.stringify(error))
          reject(error)
        },
      })
    })
  })
}
/**
 * 飞书Api鉴权操作
 */
export const configApi = () => {
  let url = window.location.href
  return new Promise((resolve, reject) => {
    request
      .post('/v1/signature', {
        url: url,
      })
      .then((res) => {
        let { appid, noncestr, signature, timestamp } = res.data
        window.h5sdk.config({
          appId: appid,
          timestamp: timestamp,
          nonceStr: noncestr,
          signature,
          jsApiList: [],
          onSuccess: (res) => {
            // alert('鉴权成功')
            console.info('鉴权成功')
            resolve()
          },
          onFail: (err) => {
            // alert('鉴权失败'+JSON.stringify(err))
            console.error(err)
            resolve()
          },
        })
      })
  })
}
/**
 * 根据经纬度获取定位具体位置
 * @param {*} latitude
 * @param {*} longitude
 */
export const getAddressByLocation = (latitude, longitude) => {
  return new Promise((resolve, reject) => {
    request
      .get('/v1/geocoder', {
        params: {
          key: 'V53BZ-DRXLX-4HF4Y-7BVDU-YIHJH-PXBGK',
          get_poi: 0,
          location: `${latitude},${longitude}`,
        },
      })
      .then((res) => {
        let data = res.data
        if (data.status == 0) {
          let address = ''
          try {
            if (
              data.result.ad_info &&
              data.result.formatted_addresses
            ) {
              let { province, city, district } =
                data.result.ad_info
              let { recommend } = data.result.formatted_addresses
              if (recommend.indexOf(province) == -1) {
                address += province
              }
              if (recommend.indexOf(city) == -1) {
                address += city
              }
              if (recommend.indexOf(district) == -1) {
                address += district
              }
              address += recommend
            } else {
              address = data.result.address
            }
          } catch (error) {
            address = data.result.address
          }
          resolve(address)
        } else {
          reject(res)
        }
      })
  })
}

/**
 * 获取今日巡店列表
 * @param {*} type
 */
export const getTargetList = (type = 0, page = 1, count = 20) => {
  return request.get('/v2/targets', {
    params: {
      type,
      page,
      count,
    },
  })
}
/**
 * 根据店铺ID获取店铺的任务列表
 * @param {*} shop_id
 */
export const getTaskList = (shop_id = '') => {
  return request.get('/v2/shop/tasks', {
    params: {
      shop_id,
    },
  })
}
/**
 * 根据店铺id，任务id获取子任务id
 * @param {*} shop_id
 * @param {*} task_id
 */
export const getSubTaskList = (shop_id = '', task_id = '') => {
  return request.get('/v2/shop/task/sheets', {
    params: {
      shop_id,
      task_id,
    },
  })
}

/**
 * 获取任务检查项的详情
 * @param {*} shop_id
 * @param {*} task_id
 * @param {*} sheet_id
 */
export const getTaskDetail = (shop_id = '', task_id = '', sheet_id = '') => {
  return request.get('/v1/shop/task/sheet/detail', {
    params: {
      shop_id,
      task_id,
      sheet_id,
    },
  })
}
/**
 * 暂存表单数据
 * @param {*} data
 */
export const stageTaskDetail = (data) => {
  return request.post('/v1/shop/task/sheet/staging', data)
}

/**
 * 提交巡检任务
 * @param {*} data
 */
export const submitForm = (data) => {
  return request.post('/v4/sheet/submit', data)
}

/**
 *
 * @param {*} shop_id
 */
export const getCheckDetail = (shop_id) => {
  return request.get('/v1/checkin/status', {
    params: { shop_id },
  })
}

/**
 * 提交巡检总结
 * @param {*} data
 */
export const submitSummary = (data) => {
  return request.post('/v1/summary/submit', data)
}

/**
 * 上传图片
 * @param {*} file
 */
export const uploadImage = (file) => {
  return new Promise((resolve, reject) => {
    const uint8Buffer = new Uint8Array(new ArrayBuffer(file.size))
    readFileBySlice(
      file.tempFilePath,
      0,
      file.size,
      uint8Buffer,
      (uint8Buffer) => {
        const upload_file = new File([uint8Buffer], file.tempFilePath)
        let formData = new FormData()
        formData.append('file', upload_file)
        formData.append('access_token', getToken())
        formData.append('biz', 'patrol')
        request.post('/file/v1/upload', formData).then((res) => {
          hideLoading()
          resolve(res.data.urls[0])
        })
      }
    )
  })
}

/**
 * 上传视频
 * @param {*} file
 */
export const uploadVideo = (file) => {
  return new Promise((resolve, reject) => {
    const uint8Buffer = new Uint8Array(new ArrayBuffer(file.size))
    readFileBySlice(
      file.tempFilePath,
      0,
      file.size,
      uint8Buffer,
      (uint8Buffer) => {
        const upload_file = new File(
          [uint8Buffer],
          file.tempFilePath.toLowerCase()
        )
        let formData = new FormData()
        formData.append('file', upload_file)
        formData.append('access_token', getToken())
        formData.append('biz', 'patrol')
        request
          .post('/video/upload', formData)
          .then((res) => {
            resolve(res.data)
          })
          .catch((err) => {
            console.error(err)
          })
      }
    )
  })
}

/**
 * 上传音频
 * @param {*} file
 */
export const uploadAudio = (file) => {
  return new Promise((resolve, reject) => {
    const uint8Buffer = new Uint8Array(new ArrayBuffer(file.size))
    readFileBySlice(
      file.tempFilePath,
      0,
      file.size,
      uint8Buffer,
      (uint8Buffer) => {
        const upload_file = new File([uint8Buffer], file.tempFilePath)
        let formData = new FormData()
        formData.append('file', upload_file)
        formData.append('access_token', getToken())
        formData.append('biz', 'patrol')
        request
          .post('/audio/upload', formData)
          .then((res) => {
            resolve(res.data)
          })
          .catch((err) => {
            alert(JSON.stringify(err))
          })
      }
    )
  })
}

// 分片读取文件
const readFileBySlice = (
  path,
  position = 0,
  total = 0,
  uint8Buffer,
  callback
) => {
  if (position >= total) {
    callback(uint8Buffer)
    return
  }
  let slice = 1024 * 1024 // 建议每一片不要超过1M，否则可能引起性能问题
  tt.getFileSystemManager().readFile({
    filePath: path,
    position: position,
    length: slice < total ? slice : total,
    success(res) {
      // 输出读取的文件内容
      const srcUint8 = new Uint8Array(res.data)
      uint8Buffer.set(srcUint8, position)
      const nextPosition = position + srcUint8.buffer.byteLength
      readFileBySlice(path, nextPosition, total, uint8Buffer, callback)
    },
    fail(res) {
      console.log('调用失败', res.errMsg)
    },
  })
}

/*获取任务检查项的详情 */
export const getImproves = (type = '', page = 1, count = 20, date = '') => {
  return request.get('/v1/shop/improves', {
    params: {
      type,
      page,
      count,
      date,
    },
  })
}

/**
 * 获取通过水印快拍上传的图片/视频资源
 * @param {*} random_id
 */
export const getUploadedUrl = (random_id) => {
  return request.get('/v1/fetch/uploaded', {
    params: { random_id },
  })
}


/**
 * 获取任务巡检报告基础数据
 * @param {*} exec_id
 */
export const getReportDetail = (exec_id, new_token, type) => {
  return request.get('/v1/exec/detail', {
    params: {
      ...(type === 'exec_id' ? { exec_id } : { sub_task_id: exec_id }),
      new_token,
    },
  })
}

/**
 * 获取巡检报告的检查项列表
 * @param {*} exec_id
 * @param {*} sheet_id
 * @param {*} type
 */
export const getReportItemList = (exec_id, sheet_id, type = 0, new_token) => {
  return request.get('/v1/exec/sheet/items', {
    params: {
      exec_id,
      sheet_id,
      type,
      new_token,
    },
  })
}
/**
 * 获取检查项详情
 * @param {*} improve_id
 */
export const getImproveDetail = (improve_id, new_token = '') => {
  return request.get('/v2/shop/improve', {
    params: {
      improve_id,
      new_token,
    },
  })
}
/**
 * 提交整改数据
 * @param {*} data
 */
export const submitImprove = (data) => {
  return request.post('/v2/shop/improve', data)
}

/**
 * 获取检查项详情
 * @param {*} item_id
 * @param {*} type
 */
export const getTaskItemDetail = (item_id, type) => {
  let params = {
    item_id,
  }
  if (!isTextEmpty(type)) {
    params.type = type
  }
  return request.get('/v1/work/item', {
    params: params,
  })
}

/**
 * 获取巡检地图信息
 * @param {*} t_exec
 * @param {*} inspector
 */
export const getMapDetail = (data) => {
  return request.get('/v2/exec/route', {
    params: data,
  })
}

/**
 * 获取门店列表
 * @param {*} page
 * @param {*} count
 */
export const getShops = (
  page = 1,
  count = 10,
  shop_name = '',
  area_id = ''
) => {
  return request.get('/v3/shops', {
    params: { page, count, shop_name, area_id },
  })
}

/**
 * 获取角色列表
 */
export const getRoles = () => {
  return request.get('/v2/roles', {
    params: { referer: 'choose' },
  })
}

/**
 * 搜索人员
 */
export const getUser = (keyword = '') => {
  return request.get('/v1/users', {
    params: { page: 1, count: 9999, keyword },
  })
}

/**
 * 获取角色下的人员列表
 * @param {*} group_id
 */
export const getRoleUsers = (group_id = '') => {
  return request.get('/v3/role', {
    params: { group_id, referer: 'choose' },
  })
}

/***
 * 获取指定门店的所有成员
 */
export const getShopUsers = (data) => {
  return request.get('/v1/shop/member', {
    params: {
      page: 1,
      count: 50,
      ...data,
    },
  })
}

/**
 * 获取巡检组列表
 */
export const getGroups = () => {
  return request.get('/v1/execute/groups', {
    params: {},
  })
}

/**
 * 获取巡检组列表
 * @param {*} page count
 */
export const getSheet = (page, count, title = '') => {
  return request.get('/v1/work/sheets', {
    params: { page, count, ...(title ? { title } : {}) },
  })
}

/**
 * 新增任务
 * @param {*} data
 */
export const submitTask = (data) => {
  return request.post('/v4/tasks', data)
}

export const getArea = () => {
  return request.get('/v2/area', {})
}

export const searchTask = (data) => {
  return request.get('/v1/target/list', {
    params: data,
  })
}

// 审核
export const submitAudit = (data) => {
  return request.post('/v1/exec/audit', data)
}

export const postUserInfo = (data) => {
  return request.post('/v1/user/info', data)
}

// 获取选择门店列表
export const getShopList = (
  page,
  count,
  data_type = 0,
  area_id = '',
  name = ''
) => {
  return request.get('/v1/shop/list', {
    params: {
      page,
      count,
      data_type,
      ...(area_id ? { area_id } : {}),
      ...(name ? { name } : {}),
    },
  })
}
// 获取企业的过期信息
export const getExpireInfo = () => {
  return request.get('/v1/user/auth')
}
// 获取最近3次不合格情况
export const getFailRecords = (data) => {
  return request.get('/v1/execute/fail/records', {
    params: data,
  })
}
// 获取关键字信息
export const getKeyInfo = (new_token) => {
  return request.get('/v1/shop/customize', {
    params: {
      new_token,
    },
  })
}
